import React from 'react'

// Components
import BannerDefault from 'components/flex/Banner/BannerDefault'
import BannerLanding from 'components/flex/Banner/BannerLanding'
import BannerVacancy from 'components/flex/Banner/BannerVacancy'

export interface BannerProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPost_Flexcontent_Flex_Banner
  location?: any
  pageContext?: any
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerProps> = ({
  fields,
  location = {},
  pageContext,
}) => {
  const banners: BannersProps = {
    default: BannerDefault,
    landing: BannerLanding,
    vacancy: BannerVacancy,
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
      pageContext={pageContext}
    />
  )
}

export default BannerShell
